import { createRouter, createWebHashHistory } from 'vue-router'

// 自动生成路由配置的函数
function generateRoutes(context) {
  const routes = [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue')
    }
  ]

  // 创建基础布局路由
  const layoutRoute = {
    path: '/',
    name: 'layouts',
    component: () => import('../layouts/BasicLayout.vue'),
    redirect: '/workorder/list', // 默认重定向到控制台页面
    children: []
  }

  // 获取所有.vue文件
  const files = context.keys()

  // 处理每个vue文件
  files.forEach(file => {
    // 跳过Login.vue，因为它已经单独配置
    if (file === './Login.vue') return

    // 移除 ./和文件扩展名 得到路径
    const path = file.replace(/^\.\/(.*)\.vue$/, '$1')
    
    // 处理Index.vue的特殊情况
    let routePath
    if (path.endsWith('/Index')) {
      // 对于目录下的Index.vue，路由路径应该是目录路径
      routePath = '/' + path.replace('/Index', '')
    } else {
      // 其他情况保持原样
      routePath = '/' + path
    }

    // 生成路由名称
    const name = path.toLowerCase().replace(/\//g, '-')

    // 生成路由配置
    const route = {
      path: routePath.toLowerCase(),
      name,
      component: () => import(`../views/${file.substring(2)}`), // 修正组件导入路径
      meta: {
        title: path.split('/').pop().replace(/([A-Z])/g, ' $1').trim(),
        titleCN: path.split('/').pop().replace(/([A-Z])/g, ' $1').trim(),
        breadcrumb: path.split('/').filter(Boolean).map(part => ({
          title: part.replace(/([A-Z])/g, ' $1').trim(),
          titleCN: part.replace(/([A-Z])/g, ' $1').trim()
        }))
      }
    }

    // 将路由添加到布局路由的子路由中
    layoutRoute.children.push(route)
  })

  // 添加布局路由到主路由数组
  routes.push(layoutRoute)
  console.log(routes)
  return routes
}

// 创建路由实例
export function createAppRouter() {
  const routes = generateRoutes(require.context('../views', true, /\.vue$/))
  
  return createRouter({
    history: createWebHashHistory(),
    routes
  })
}